/** @format */

import React from 'react';
import { observer, inject } from 'mobx-react';
import { Form } from 'semantic-ui-react';
import AdminPage from '../shared/AdminPage/AdminPage';
import AdminPageModal from '../shared/AdminPage/AdminPageModal/AdminPageModal';

@inject('CarPartsStore')
@observer
class AdminParts extends AdminPage {
  getStore = () => {
    const { CarPartsStore } = this.props;
    return CarPartsStore;
  };

  renderTableModal = () => {
    const { CarPartsStore } = this.props;

    return (
      <AdminPageModal
        open={CarPartsStore.edit.modal}
        errors={CarPartsStore.edit.errors}
        toggleEditModal={CarPartsStore.toggleEditModal}
        currentItem={CarPartsStore.edit.currentItem}
        onSubmit={CarPartsStore.submit}
        onDelete={CarPartsStore.deleteItem}
        isEdit={CarPartsStore.edit.currentItem.uid}
      >
        <Form.Group widths="equal">
          <Form.Input
            onChange={e =>
              CarPartsStore.handleInputChange(e.target.value, 'name')
            }
            type="name"
            name="recallDate"
            label="Nome Ricambio"
            value={CarPartsStore.edit.currentItem.data.name}
          />
          <Form.Select
            search
            onChange={(e, input) =>
              CarPartsStore.handleInputChange(input.value, 'whCode')
            }
            value={CarPartsStore.edit.currentItem.data.whCode}
            options={[
              {
                text: 'Lamierati',
                value: 'LAMIER',
              },
              {
                text: 'Carrozieria leggera',
                value: 'CARLEG',
              },
              {
                text: 'Meccanica Pesante',
                value: 'MECPES',
              },
              {
                text: 'Meccanica Leggera',
                value: 'MECLEG',
              },
            ]}
            name="whCode"
            label="Zona Magazzino"
            placeholder="Zona Magazzino"
          />
        </Form.Group>
      </AdminPageModal>
    );
  };
}

export default AdminParts;
